import { NotificationSettings } from '../../../global/models'

type NotificationSettingItem = {
  label: string;
  description?: string;
  notificationKey: NotificationSettingsKeys;
  email?: boolean;
  app?: boolean;
  noApp?: boolean;
  noEmail?: boolean;
}

type NotificationSettingsKeys = 'job-progress-updated' | 'job-submitted' | 'job-closed' | 'message-created' | 'issue-opened' | 'issue-updated' | 'issue-closed' | 'job-document-purged' | 'job-claimed' | 'job-surrendered' | 'offer-surrendered' | 'relationship-ended'

export default class NotificationSettingsSerializer {
  static _listItems: NotificationSettingItem[] = [
    {
      label: 'Progress Updates',
      description: 'When the job is moved between its different stages, for example being moved from "In Progress" to "Customer Review"',
      notificationKey: 'job-progress-updated'
    },
    {
      label: 'Job Submitted',
      description: 'When the job is submitted by the customer',
      notificationKey: 'job-submitted'
    },
    {
      label: 'Job Closed',
      description: 'When one of your jobs has been finished',
      notificationKey: 'job-closed'
    },
    {
      label: 'Message Created',
      description: 'When your translator sends a message, and you haven\'t read any of the job\'s messages in the last hour',
      notificationKey: 'message-created'
    },
    {
      label: 'Issue Opened',
      description: 'When your translator opens an issue against you',
      notificationKey: 'issue-opened'
    },
    {
      label: 'Issue Updated',
      description: 'When an issue on one of your open jobs is updated',
      notificationKey: 'issue-updated'
    },
    {
      label: 'Issue Closed',
      description: 'When an issue on one of your open jobs has been closed',
      notificationKey: 'issue-closed'
    },
    {
      label: 'Job Document Removal',
      description: 'A warning sent out before any sensitive job documents are permanently removed from the system',
      notificationKey: 'job-document-purged'
    },
    {
      label: 'Job Claimed',
      description: 'When one of your jobs is claimed by a provider',
      notificationKey: 'job-claimed'
    },
    {
      label: 'Job Surrendered',
      description: 'When one of your jobs is surrendered back to your available pool',
      notificationKey: 'job-surrendered'
    },
    {
      label: 'Provider Offer Response',
      description: 'When a provider responds to one of your active relationship offers',
      notificationKey: 'offer-surrendered',
      noApp: true
    },
    {
      label: 'Provider Relationship Terminated',
      description: 'When one of your provider relationships is terminated by the provider',
      notificationKey: 'relationship-ended',
      noApp: true
    }
  ]

  static toList(settings: NotificationSettings[]): NotificationSettingItem[] {
    return this._listItems.map((item) => {
      const setting = settings.find(s => s.notificationKey === item.notificationKey)
      return {
        label: item.label,
        description: item.description,
        notificationKey: item.notificationKey,
        email: setting?.email,
        app: setting?.app,
        noApp: item.noApp,
        noEmail: item.noEmail
      }
    })
  }
}
